<div class="info-modal__title">
  <app-game-icon game="Plinko"></app-game-icon>
  <h2>Plinko</h2>
</div>
<div class="info-modal__body">
  <p>
    Drop a ball through a field of pegs and watch it bounce its way down to a
    multiplier slot. The further the ball travels from the center, the higher
    the multiplier — and the lower the chance to land there.
  </p>
  <ul>
    <li>
      All games are played using Provably Fair, you can verify after the bet
      that your outcome was not altered or tampered with.
    </li>
    <li>
      Pick a risk level — Low, Medium or High — to change the spread of
      multipliers across the board.
    </li>
    <li>
      The number of rows controls how many peg layers the ball passes through;
      more rows mean bigger top multipliers and tighter middle ones.
    </li>
    <li>
      You can drop multiple balls in a row — each ball is an independent bet
      with its own outcome.
    </li>
  </ul>
</div>
<app-info-modal-max-payout [maxPayout]="MAX_PAYOUT"></app-info-modal-max-payout>
